import React from 'react';
import Slider from 'react-slick';
import ScrollAnimation from 'react-animate-on-scroll';
import { useTranslation } from 'react-i18next';

const PrevArrow = ( props ) => {
    const { onClick } = props;
    return <button className="slide-arrow prev-arrow" onClick={ onClick }><i className="icon-arrow-left-line"></i></button>
}

const NextArrow = (props) => {
    const { onClick } = props;
    return <button className="slide-arrow next-arrow" onClick={ onClick }><i className="icon-arrow-right-line"></i></button>
}

const CategoryFour = ( { wrapperClass, itemClass } ) => {
    const { t } = useTranslation();
    const sliderSettings = {
        dots: false,
        infinite: true,
        arrows: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4
                }
            }, 
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }, 
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }, 
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const items = [
        {
            title: t('category1Title'),
            numberOfCourses: t('category1Desc'),
            image: 'category-01.png',
            shape: 'shape-bg-1',
            link: 'programs/for-people-with-disabilities'
        },
        {
            title: t('category2Title'),
            numberOfCourses: t('category2Desc'),
            image: 'category-02.png',
            shape: 'shape-bg-2',
            link: 'programs/for-social-experts'
        },
        {
            title: t('category3Title'),
            numberOfCourses: t('category3Desc'),
            image: 'category-03.png',
            shape: 'shape-bg-3',
            link: 'programs/for-employers'
        }
    ];

    return (
        <Slider 
            className={ wrapperClass || 'col-lg-12 mt--60 mb_dec--20 slick-activation-wrapper service-activation-item5 edu-slick-arrow-top' }
            { ...sliderSettings }
        >
            { items.map( ( data , i ) => (
                <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    className={ itemClass || 'single-slick-card' }
                    animateOnce={ true }
                    key={ i }
                >
                    <div className={`service-card service-card-8 ${data.shape}`}>
                        <div className="inner">
                            <div className="icon">
                                <a href={ data.link }>
                                    <img src={`${process.env.PUBLIC_URL}./images/category/category-04/${ data.image }`} alt="Category Thumb" />
                                </a>
                            </div>
                            <div className="content">
                                <h6 className="title"><a href={ data.link }>{ data.title }</a></h6>
                                <span>{ data.numberOfCourses }</span>
                            </div>
                            <div className="hover-action">
                                <a className="read-more-btn" href={ data.link }><i className="icon-arrow-right-line-right"></i></a>
                            </div>
                        </div>
                    </div>
                </ScrollAnimation>
            ) ) }
        </Slider>
    )
}

export default CategoryFour;